import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, finalize, map, of } from "rxjs";
import { AuthService } from "../../domain/auth/application/auth.service";
import { UserStore } from "../store/user.store";
import { LoaderStore } from "../store/loader.store";

export function authGuard() {
  const userStore = inject(UserStore);
  const router = inject(Router);
  const authService = inject(AuthService);
  const loaderStore = inject(LoaderStore);

  // Already loaded this session — no extra network call needed
  if (userStore.user()) return true;

  // Page refresh: try to restore user from the session cookie
  loaderStore.show();

  return authService.getSession().pipe(
    map((session) => {
      if (!session) {
        return router.createUrlTree(["/"]);
      }

      userStore.setUser(session.user);
      return true;
    }),
    catchError(() => of(router.createUrlTree(["/"]))),
    finalize(() => loaderStore.hide())
  );
}
